import styled from 'styled-components/macro'

const SelectedFilterContainer = styled.span`
  display: inline-block;
`

export default SelectedFilterContainer
